import { render, staticRenderFns } from "./config-backup-modal.vue?vue&type=template&id=9aa50bb2&"
import script from "./config-backup-modal.vue?vue&type=script&lang=js&"
export * from "./config-backup-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports